import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import PerusahaanPage from "./pages/Perusahaan";
import AnakPage from "./pages/Anak";
import AnakDetail from "./pages/AnakDetail";
import VoucherPage from "./pages/Voucher";
import VoucherMassal from "./pages/VoucherMassal";
import KasbonPage from "./pages/Kasbon";
import GajianPage from "./pages/Gajian";
import SlipPage from "./pages/Slip";
import Pengaturan from "./pages/Pengaturan";
import KehadiranPage from "./pages/Kehadiran";
import PeralatanPage from "./pages/Peralatan";
import { PortalAuthProvider } from "./context/PortalAuthContext";
import PortalLogin from "./pages/portal/PortalLogin";
import PortalLayout, { PortalProtected } from "./pages/portal/PortalLayout";
import PortalHome from "./pages/portal/PortalHome";
import PortalRiwayat from "./pages/portal/PortalRiwayat";
import PortalPeralatan from "./pages/portal/PortalPeralatan";

const Protected = ({ children }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null)
    return <div data-testid="auth-loading" className="flex min-h-screen items-center justify-center text-sm text-gray-500">Memuat…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <PortalAuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/anak/login" element={<Navigate to="/portal/login" replace />} />
          <Route path="/portal/login" element={<PortalLogin />} />
          <Route path="/portal" element={<PortalProtected><PortalLayout /></PortalProtected>}>
            <Route index element={<PortalHome />} />
            <Route path="riwayat" element={<PortalRiwayat />} />
            <Route path="peralatan" element={<PortalPeralatan />} />
          </Route>
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/kehadiran" element={<KehadiranPage />} />
            <Route path="/peralatan" element={<PeralatanPage />} />
            <Route path="/" element={<Dashboard />} />
            <Route path="/voucher" element={<VoucherPage />} />
            <Route path="/voucher/massal" element={<VoucherMassal />} />
            <Route path="/kasbon" element={<KasbonPage />} />
            <Route path="/gajian" element={<GajianPage />} />
            <Route path="/slip/:period/:anakId" element={<SlipPage />} />
            <Route path="/anak" element={<AnakPage />} />
            <Route path="/anak/:id" element={<AnakDetail />} />
            <Route path="/perusahaan" element={<PerusahaanPage />} />
            <Route path="/pengaturan" element={<Pengaturan />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors theme="dark" />
      </PortalAuthProvider>
    </AuthProvider>
  );
}

export default App;
